import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import img1 from '../assets/about/12102001.jpg'
import img2 from '../assets/about/12102002.jpg'
import img3 from '../assets/about/12102003.jpg'
import img4 from '../assets/about/12102004.jpg'
import img6 from '../assets/icons/user-1.png'
import img7 from '../assets/others/11102040.png'
import tr1 from '../assets/trainer/siva.jpg'
import tr2 from '../assets/trainer/Raja.jpg'
import tr3 from '../assets/trainer/rajiv.jpg'
import tr4 from '../assets/trainer/Sateesh.jpg'
import tr5 from '../assets/trainer/sada.jpg'
import tr6 from '../assets/trainer/chaitanya.jpg'
import tr7 from '../assets/trainer/charan.jpg'
import tr8 from '../assets/trainer/ram.jpg'
import g1 from '../assets/gallery/1.jpeg'
import g2 from '../assets/gallery/2.jpeg'
import g3 from '../assets/gallery/3.jpeg'
import g5 from '../assets/gallery/5.jpg'
import g6 from '../assets/gallery/6.jpg'
import g7 from '../assets/gallery/7.jpg'
import g8 from '../assets/gallery/8.jpeg'
import arrow from '../assets/arrow-down-right.svg'
import { Link } from 'react-router-dom'
import Enrollaction from '../Components/Enrollaction/Enrollaction'
import Partnersec from '../Components/Partnersec/Partnersec'
import Authabout from '../Components/Authabout/Authabout'
import Eventsec from '../Components/Eventsec/Eventsec'
import Clientsay from '../Components/Clientsay/Clientsay'
import { Helmet } from 'react-helmet-async'


const About = () => {
  return (
    <div>
      <Helmet>
      <title>About Us – Best VLSI Training Institute in India | Takshila VLSI</title>
      <meta name="description" content="Learn about job-oriented VLSI courses, expert trainers, practical training, and placement support in Bangalore and Hyderabad with Takshila VLSI." />
      <link rel="canonical" href="https://www.takshila-vlsi.com/about-us/" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content="About Us – Best VLSI Training Institute in India | Takshila VLSI" />
      <meta property="og:description" content="Learn about job-oriented VLSI courses, expert trainers, practical training, and placement support in Bangalore and Hyderabad with Takshila VLSI." />
      <meta property="og:url" content="https://www.takshila-vlsi.com/about-us/" />
      <meta property="og:site_name" content="Takshila VLSI" />
      <meta property="article:modified_time" content="2022-03-01T13:54:06+00:00" />
      <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
        <Header/>
        <main>
        <section class="section-banner pg-banner ws-section pt-5 bg-img dark-bg">
              <div class="container text-center">
                          <div class="row justify-content-around ">
                              <div class="col-md p-lg-5">
                                <div class="pg-title-sec pl-r-12">
                                    <h1 className='pg-title pb-3'>Welcome to Takshila Institute of VLSI</h1>
                                    <p className='pg-title-desc'>Takshila VLSI institute is among the top 10 VLSI training institutes in India. At Takshila, we understand the changing demands in the field of VLSI.</p>
                                </div>
                              </div>
                          </div>
                          <div class="row justify-content-center img-radius">
                            <div class="col-md-4 align-self-end d-none d-sm-block">
                            <img src={img1} alt=''/>
                            </div>
                            <div class="col-md-4 align-self-end">
                            <img src={img2} alt=''/>
                            </div>
                            <div class="col-md-4 align-self-end d-none d-sm-block">
                            <img src={img3} alt=''/>
                            </div>
                          </div>
              </div>
          </section>
          <section className='pg-section p-lg-5 bg-6'>
                <div class="container">
                          <div class="row justify-content-around text-center">
                              <div class="col-md p-lg-5">
                                    <h2 className='ws-section_heading pd-03'>Best VLSI and Physical Design Training Institute</h2>
                              </div>
                          </div>
                          <div class="row justify-content-between">
                            <div class="col-md-7">
                              <p>Takshila VLSI institute is among the top 10 VLSI training institutes in India. At Takshila, we understand the changing demands in the field of VLSI. Our courses are designed to offer students hands-on experience in industry trends. We focus on the overall growth and development of the student. At Takshila, our courses are job oriented and our trainers have over 12 year’s industry experience.</p>

                              <p>Since our inception, we have strived to remain among the best VLSI training institutes. We do this through intensive training, affiliation with top-tier design industries and effective placement programs. Our primary aim at Takshila is to connect the student’s skill set with industry requirements. We achieve this through teaching job oriented VLSI courses. We also partner with top-tier design industries for student’s placement programs.</p>

                              <p>We place high importance on excellence and student’s development. That is why our trainers are selected with 12+ experience, worked with Tier-1 semiconductor companies such as Qualcomm, Intel, Broadcom, AMD, Analog Devices, IBM, STMicroelectronics, Synopsys, Texas Instruments and Xilinx. We have a very conducive learning environment with modern facilities and learning tools. Our student’s excellent performance in the field has continually ranked us among the top 10 physical design training institutes here in Bangalore.</p>

                              <p>Sign up today to be among our next set of outstanding VLSI professionals. Contact our student representatives or visit our study center for further information.
                              </p>
                            </div>
                            <div class="col-md-4 img-radius">
                            <img src={img4} alt=''/>
                            </div>
                          </div>
                          
              </div>
          </section>
          <section className='pg-section p-lg-5'>
                <div class="container">
                          <div class="row justify-content-around text-center">
                              <div class="col-md p-5">
                                    <h2 className='ws-section_heading pd-03'>Our Trainers</h2>
                              </div>
                          </div>
                          <div class="row pb-lg-5">
                            <div class="col-md-4 img-radius pb-4">
                              <a href='/teachers/siva/'>
                              <div className='trainer-box'>
                                <div className='content-box d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title'>Mr.Siva</h5>
                                  <h6 className='trainer-desig'>Specialist Design For Test (DFT)</h6>
                                  </div>
                                  <div className='trainer-button'><img src={arrow} alt=''/></div>
                                </div>
                                <div className='trainer-img'>
                              <img src={tr1} alt=''/>
                              </div>
                              </div>
                              </a>
                            </div>
                            <div class="col-md-4 img-radius pb-4">
                              <a href='/teachers/raja/'>
                              <div className='trainer-box'>
                                <div className='content-box d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title'>Mr.Raja</h5>
                                  <h6 className='trainer-desig'>Embedded Systems Specialist </h6>
                                  </div>
                                  <div className='trainer-button'><a href='/teachers/raja/'><img src={arrow} alt=''/></a></div>
                                </div>
                                <div className='trainer-img'>
                              <img src={tr2} alt=''/>
                              </div>
                              </div>
                              </a>
                            </div>
                            <div class="col-md-4 img-radius pb-4">
                              <a href='/teachers/rajiv/'>
                              <div className='trainer-box'>
                                <div className='content-box d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title'>Mr.Rajiv</h5>
                                  <h6 className='trainer-desig'>ASIC Verification Specialist
                                  </h6>
                                  </div>
                                  <div className='trainer-button'><a href='/teachers/rajiv/'><img src={arrow} alt=''/></a></div>
                                </div>
                                <div className='trainer-img'>
                              <img src={tr3} alt=''/>
                              </div>
                              </div>
                              </a>
                            </div>
                            <div class="col-md-4 img-radius pb-4">
                              <a href='/teachers/sateesh/'>
                              <div className='trainer-box'>
                                <div className='content-box d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title'>Mr.Sateesh</h5>
                                  <h6 className='trainer-desig'>Analog Circuit Design Specialist
                                  </h6>
                                  </div>
                                  <div className='trainer-button'><a href='/teachers/sateesh/'><img src={arrow} alt=''/></a></div>
                                </div>
                                <div className='trainer-img'>
                              <img src={tr4} alt=''/>
                              </div>
                              </div>
                              </a>
                            </div>
                            <div class="col-md-4 img-radius pb-4">
                              <a href='/teachers/sadakshari/'>
                              <div className='trainer-box'>
                                <div className='content-box d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title'>Mr.Sadakshari</h5>
                                  <h6 className='trainer-desig'>Analog Layout Design
                                  </h6>
                                  </div>
                                  <div className='trainer-button'><a href='/teachers/sadakshari/'><img src={arrow} alt=''/></a></div>
                                </div>
                                <div className='trainer-img'>
                              <img src={tr5} alt=''/>
                              </div>
                              </div>
                              </a>
                            </div>
                            <div class="col-md-4 img-radius pb-4">
                              <a href='/teachers/chaitanya/'>
                              <div className='trainer-box'>
                                <div className='content-box d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title'>Mr.Chaitanya</h5>
                                  <h6 className='trainer-desig'>Specialist Physical Design
                                  </h6>
                                  </div>
                                  <div className='trainer-button'><a href='/teachers/chaitanya/'><img src={arrow} alt=''/></a></div>
                                </div>
                                <div className='trainer-img'>
                              <img src={tr6} alt=''/>
                              </div>
                              </div>
                              </a>
                            </div>
                            <div class="col-md-4 img-radius pb-4">
                              <a href='/teachers/charan/'>
                              <div className='trainer-box'>
                                <div className='content-box d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title'>Mr.Charan</h5>
                                  <h6 className='trainer-desig'>RTL Coding and FPGA Specialist
                                  </h6>
                                  </div>
                                  <div className='trainer-button'><a href='/teachers/charan/'><img src={arrow} alt=''/></a></div>
                                </div>
                                <div className='trainer-img'>
                              <img src={tr7} alt=''/>
                              </div>
                              </div>
                              </a>
                            </div>
                            <div class="col-md-4 img-radius pb-4">
                              <a href='/teachers/ram/'>
                              <div className='trainer-box'>
                                <div className='content-box d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title'>Mr.Ram</h5>
                                  <h6 className='trainer-desig'>Analog Layout Design Expert
                                  </h6>
                                  </div>
                                  <div className='trainer-button'><a href='/teachers/ram/'><img src={arrow} alt=''/></a></div>
                                </div>
                                <div className='trainer-img'>
                              <img src={tr8} alt=''/>
                              </div>
                              </div>
                              </a>
                            </div>
                          </div>
                          
              </div>
          </section>
          <Authabout/>
          <section className='ws-section winning-sec pb-lg-5'>
            <div class="container">
                    <div class="row">
                        <div class="col-lg-12 text-center">
                        <h2 className='ws-section_heading pd-03'>Our Unique Features</h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                        <div class="row">
                            <div class="col-lg-6">
                                <div className='icon-card bg-10 radius-1 mb-3'>
                                    <div className='icon mb-3'> <img src={img6} alt=''/></div>
                                    <div className='icon-content'>
                                        <div className='icon-card-head mb-2'>Course delivered by Experts</div>
                                        <p>Experts in the industry teach our various courses to students. At Takshila, our experts share their experience and help build the career of our students in the VLSI industry. You have the opportunity of carrying out practical applications and examples.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                            <div className='icon-card bg-10 radius-1 mb-3'>
                                    <div className='icon mb-3'> <img src={img6} alt=''/></div>
                                    <div className='icon-content'>
                                        <div className='icon-card-head mb-2'>100% placement support</div>
                                        <p>Our main goal is to help engineers build a successful career in the VLSI industry. Not only we do train you, but we also coach you in order to become a best Chip Designer. Our training process allows students to learn even complex technologies within a short time space and transforming them into professionals in no time. </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                            <div className='icon-card bg-10 radius-1 mb-3'>
                                    <div className='icon mb-3'> <img src={img6} alt=''/></div>
                                    <div className='icon-content'>
                                        <div className='icon-card-head mb-2'>Superior Training infrastructure and Methodology</div>
                                        <p>Industry experts carefully designed the training program based on the career growth and job opportunities available in the VLSI industry. We use an unique training methodology for our students with 70% of the course time allocated to the labs, mini-projects, and the final projects. However, the other 30% is allocated to imparting the technologies to our student.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                            <div className='icon-card bg-10 radius-1 mb-3'>
                                    <div className='icon mb-3'> <img src={img6} alt=''/></div>
                                    <div className='icon-content'>
                                        <div className='icon-card-head mb-2'>Powerful EDA Tools
                                        </div>
                                        <p>We utilize industrial standard EDA tools for hands-on training of our students. During your period as a trainee in our VLSI institute, EDA tools are accessible 24×7 through our vpn service.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                        <div class="col-lg-6">
                        <img src={img7} alt=''/>
                        </div>
                    </div>
                    </div>
            </section>
          <Enrollaction/>
          <section className='gallery-section'>
          <div class="container">
                          <div class="row justify-content-around text-center">
                              <div class="col-md p-5">
                                    <h2 className='ws-section_heading pd-03'>Life at Takshila VLSI
                                    </h2>
                              </div>
                          </div>
                          
                          <div class="row">
                      <div class="col-lg-4 col-md-12 mb-4 mb-lg-0">
                        <img
                          src={g1}
                          class="w-100 shadow-1-strong rounded mb-4"
                          alt="Boat on Calm Water"
                        />

                        <img
                          src={g3}
                          class="w-100 shadow-1-strong rounded mb-4"
                          alt="Wintry Mountain Landscape"
                        />
                      </div>

                      <div class="col-lg-4 mb-4 mb-lg-0">
                        <img
                          src={g2}
                          class="w-100 shadow-1-strong rounded mb-4"
                          alt="Mountains in the Clouds"
                        />

                        <img
                          src={g5}
                          class="w-100 shadow-1-strong rounded mb-4"
                          alt="Boat on Calm Water"
                        />
                      </div>

                      <div class="col-lg-4 mb-4 mb-lg-0">
                        <img
                          src={g6}
                          class="w-100 shadow-1-strong rounded mb-4"
                          alt="Waves at Sea"
                        />

                        <img
                          src={g7}
                          class="w-100 shadow-1-strong rounded mb-4"
                          alt="Yosemite National Park"
                        />
                        <img
                          src={g8}
                          class="w-100 shadow-1-strong rounded mb-4"
                          alt="Yosemite National Park"
                        />
                      </div>
                    </div>
            </div>
          </section>
          <section className='ws-section winning-sec pb-5'>
            <div class="container">
                    <div class="row">
                        <div class="col-lg text-center">
                        <h2 className='ws-section_heading pd-03'>Events/Webinar</h2>
                        </div>
                    </div>
                    <Eventsec/> 
             </div>
          </section>
          <section className='ws-section clientsay-section bg-5 dark-bg pb-5'>
            <div class="container">
                    <div class="row">
                        <div class="col-lg text-center">
                        <h2 className='ws-section_heading pd-03'>What Our Clinet Says</h2>
                        </div>
                    </div>
                    <Clientsay/> 
             </div>
          </section>
          <Partnersec/> 
        </main>
        <Footer/>
        
    </div>
  )
}

export default About